// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.D2kBF{position:fixed;bottom:16px;right:16px;z-index:1001;overflow:hidden;display:flex;flex-direction:column;box-shadow:0px 4px 8px rgba(40,40,99,.1);box-sizing:content-box;transition:width 250ms ease-in-out,height 250ms ease-in-out}.D2kBF.d8VRt{width:482px;height:calc(100vh - 60px - 16px - 16px)}.D2kBF.tP84l{width:260px;height:60px;cursor:pointer}.dlaQm{display:flex;flex-direction:column;gap:16px}.rfqPb{flex:1 0 auto}.XYV1J{display:flex;flex-direction:column;gap:4px;color:#282863}.J6LkR{display:flex;flex-direction:column;align-items:flex-end}.gxrpe{padding-inline:8px}.d8tAQ{align-items:flex-start;padding-inline:8px}.eFrix{display:flex;flex-direction:column;gap:8px}._BKrS{margin-top:8px}._BKrS .wk03q{justify-content:flex-start;block-size:auto;min-block-size:32px;white-space:normal}.wk03q{text-align:left;overflow-wrap:anywhere}.FPfeN{flex-shrink:0;display:flex;align-items:center;justify-content:space-between;gap:12px;padding:8px 20px}.amPQB{flex-shrink:0;display:flex;flex-direction:column;padding:0 20px 16px}.amPQB>*{width:100%}@media(prefers-reduced-motion: reduce){.D2kBF{transition:none}}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple100": `#dad0fe`,
	"purple300": `#c3b3fc`,
	"purple400": `#b4a1fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"chartBlue": `#6a9ff0`,
	"chartPeach": `#fbd499`,
	"chartCyan": `#a9e5f2`,
	"chartPink": `#fda5ef`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"sh10": `0px 4px 12px rgba(40,40,99,.06)`,
	"sh20": `0px 4px 16px rgba(40,40,99,.08)`,
	"sh40": `0px 4px 24px rgba(40,40,99,.12)`,
	"sh60": `0px 4px 14px rgba(40,40,99,.24)`,
	"root": `D2kBF`,
	"open": `d8VRt`,
	"collapsed": `tP84l`,
	"answerParts": `dlaQm`,
	"threadContent": `rfqPb`,
	"emptyState": `XYV1J`,
	"userMessage": `J6LkR`,
	"thinkingIndicator": `gxrpe`,
	"assistantMessage": `d8tAQ`,
	"clarify": `eFrix`,
	"suggestions": `_BKrS`,
	"suggestion": `wk03q`,
	"errorFooter": `FPfeN`,
	"inputBlock": `amPQB`
};
export default ___CSS_LOADER_EXPORT___;
